import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ONE_MIN_IN_MS = 1000 * 60;
const ONE_HOUR_IN_MS = 1000 * 60 * 60;
const ONE_DAY_IN_MS = 1000 * 60 * 60 * 24;

export const useCalculateElapsedTime = (createdTimestampUTC: number) => {
  const { t } = useTranslation('notifications');
  const [timeElepse, setTimeElapse] = useState<string>('');
  const [timeElapseTimeout, setTimeElapseTimeout] = useState<ReturnType<typeof setTimeout>>();

  const calculateElapsedTime = useCallback(() => {
    if (!createdTimestampUTC) return;

    clearTimeout(timeElapseTimeout as number | undefined);

    const timeNow = new Date().getTime();
    const timeDiff = timeNow - createdTimestampUTC;
    let delay = 0;

    if (timeDiff < ONE_MIN_IN_MS) {
      setTimeElapse(t('now'));
      delay = ONE_MIN_IN_MS - timeDiff;
    } else if (timeDiff < ONE_HOUR_IN_MS) {
      setTimeElapse(Math.floor(timeDiff / ONE_MIN_IN_MS) + 'm ' + t('ago'));
      delay = ONE_MIN_IN_MS - (timeDiff % ONE_MIN_IN_MS);
    } else if (timeDiff < ONE_DAY_IN_MS) {
      setTimeElapse(Math.floor(timeDiff / ONE_HOUR_IN_MS) + 'h ' + t('ago'));
      delay = ONE_HOUR_IN_MS - (timeDiff % ONE_HOUR_IN_MS);
    } else {
      setTimeElapse(Math.floor(timeDiff / ONE_DAY_IN_MS) + 'd ' + t('ago'));
      delay = ONE_DAY_IN_MS - (timeDiff % ONE_DAY_IN_MS);
    }

    setTimeElapseTimeout(setTimeout(() => calculateElapsedTime(), delay));
  }, [timeElapseTimeout, setTimeElapseTimeout, createdTimestampUTC, t]);

  useEffect(calculateElapsedTime, [createdTimestampUTC]);

  return {
    timeElepse,
  };
};
